export default __webpack_public_path__ + "static/media/245.1faaf577.gif";